import { FC } from "react";
import { WheelRaffleItemStatus } from "entities/wheel-raffle";
import type { Raffle } from "entities/wheel-raffle";
import { DrawRaffleButton, useAutoDraw } from "features/draw-wheel-raffle";

interface Props {
  raffle: Raffle;
}

// До старта draw-now вернёт not_started, после розыгрыша — already_drawn.
const DRAWABLE = new Set([
  WheelRaffleItemStatus.LIVE,
  WheelRaffleItemStatus.ENDED,
]);

export const CreatorPanel: FC<Props> = ({ raffle }) => {
  // Истечение таймера разыгрывает промо так же, как кнопка Start.
  useAutoDraw({
    raffleId: raffle.id,
    endsAt: raffle.ends_at,
    enabled: raffle.status !== WheelRaffleItemStatus.DRAWN,
  });

  return DRAWABLE.has(raffle.status) ? (
    <DrawRaffleButton raffleId={raffle.id} />
  ) : null;
};
